import {HttpErrorResponse, HttpEventType, HttpInterceptorFn} from '@angular/common/http';
import {catchError, map, throwError} from "rxjs";
import {environment} from "../../environments/environment";

import jwt_decode, {jwtDecode} from 'jwt-decode';

export const httpconfigInterceptor: HttpInterceptorFn = (req, next) => {

  if (!req.headers.has('Content-Type') && (req.method !== 'DELETE') && (req.params.get('multipart') != 'true')) {
    req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    req = req.clone({ headers: req.headers.set('Accept', 'application/json') });
  }

  const requestId = Math.random().toString(36).substr(2, 7);
  req = req.clone({ headers: req.headers.set('X-Request-ID', requestId)});

  // Solo para pruebas locales con ng serve sustituir el token Bearer por uno activo desde QA
  if(!environment.production)
    req = req.clone({ headers: req.headers.set('authorization', 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJJeUZoMEJ6WEZwUlBDWHQwV2txalhPb05lb3dIMDVMaDhLb3lLdGJKRVBzIn0.eyJleHAiOjE3ODU3NzcwNTIsImlhdCI6MTc4NTc2OTg1MiwiYXV0aF90aW1lIjoxNzg1NzY4MzgyLCJqdGkiOiJlZWUwOTU1ZS1mODAyLTQ5MDYtYTk4YS1kMGU2NGE3MWIxZTciLCJpc3MiOiJodHRwczovL2tleWNsb2FrLmNvbmVjdGFtb2JpbGl0eS5jbC9yZWFsbXMvQ09ORUNUQS1NQUlOIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6ImRkZmY3ZTE0LTdjNjEtNDZjOC1hOTAyLTI2ZjQxYWU0MTkwOSIsInR5cCI6IkJlYXJlciIsImF6cCI6ImNvbmVjdGEtcGxhdGFmb3JtYS1wdWJsaWMiLCJzaWQiOiI3MDIzNzE2YS03OGQ3LTRiNWEtYmE5NS0wYTM3ZTRiY2MzN2YiLCJhY3IiOiIwIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHBzOi8vY29uZWN0YS5jdXJzb3IuY2wiLCJodHRwczovL2NvbmVjdGEucWEuY3Vyc29yLmNsIiwiaHR0cDovL2xvY2FsaG9zdDo0MjAwLyoiLCJodHRwczovL2NvbmVjdGEuY3Vyc29yLmNsL3dlYi1hZG1pbi1qb3IvYWRtaW4vZGVzcGFjaGFkb3IiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImRlZmF1bHQtcm9sZXMtY29uZWN0YS1tYWluIiwib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGNvbXBhbmllcyB1c2VyLWlwLWxpc3RlbmVyIGVtYWlsIHByb2ZpbGUiLCJjb21wYW5pZXMiOiJDMTciLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsIm5hbWUiOiJQUlVFQkEgQ1VSU09SIiwiZ3JvdXBzIjpbIkFETUlOIl0sImNsaWVudF9pcCI6IjI4MDA6MzAwOjZmNzE6NjM5MDo3NGI5OjhhOTg6OGViNjo4NjA5IiwicHJlZmVycmVkX3VzZXJuYW1lIjoiODE2MjIyOTAtNyIsImdpdmVuX25hbWUiOiJQUlVFQkEiLCJmYW1pbHlfbmFtZSI6IkNVUlNPUiJ9.BEfYaz5h42M6pxgMuX7d0R-UWlQylcqZAC2r9eSr6m0f2MNEDLeflFcYCB-gk_JFO3D9HBkT_1-oi95WAJ59560in1p1b2qtc71aCyUcwGPEEm9UNi-pSCvoD70R4h9ZyzhtAixRt7kQ7Aluda6nfpJ5sMBpuSnW25TS3lfENNLdkh8Wu7g6x5VG-j2PhAVuryB03wFpZtkGzM_4De1ORNBfO1IlVU62x40pAxeU26ENIHFi8ou79O6fP-4OEet2lzmHt6G8hT-Xs8QZNwlCHmE_9IbaYoQWfGZ3TE7u_6Su66mhlG1wx-mS_3Fp7tZsSesi6e2rZo4AhI_D41upRA') });
  //return next(req);

  const decodedToken = jwtDecode(req.headers.get('authorization'));
  //console.log('jojojo', decodedToken);

  // HTTP requests
  return next(req).pipe(
    map(event => {
      if (event.type === HttpEventType.Response) {
        //this.afterRequestHideLoader();
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      //console.log('interceptor handle error', error);
      //this.afterRequestHideLoader();
      error['requestId'] = requestId;
      return throwError(error);
    })
  );
};
